import React from 'react';
export function EditorListBulletIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.024 7.976l12 .018a1 1 0 100-2l-12-.018a1 1 0 100 2zM20.02 10.994l-12-.018a1 1 0 100 2l12 .018a1 1 0 000-2zM20.012 15.994l-12-.018a1 1 0 100 2l12 .018a1 1 0 000-2zM3.308 6.249l.036-.035a.965.965 0 011.364 0l.036.036a.964.964 0 01-.002 1.363l-.036.036a.965.965 0 01-1.364 0l-.04-.04a.964.964 0 01.006-1.36zM3.302 11.247l.036-.035a.965.965 0 011.365.002l.035.035a.964.964 0 01-.003 1.364l-.035.035a.965.965 0 01-1.365-.002l-.038-.04a.964.964 0 01.002-1.363l.003.004zM3.293 16.287l.036-.035a.965.965 0 011.365.002l.035.034a.965.965 0 01-.002 1.365l-.034.035a.966.966 0 01-1.366-.002l-.036-.035a.964.964 0 01.001-1.363l.001-.001z"
  }));
}